import React, { useEffect, useState, Fragment, useRef } from "react";
import { EmployeeCropTableContent } from '../../../Common/Table/tableContent';

export default class ComponentToPrint extends React.Component {
    render() {

        const searchData = this.props.searchData;
        const resultData = this.props.data;
        const contentRowNames = this.props.rowNames;
        const detailCard = this.props.detailCard;
        const monthlyCollectionDetails = this.props.monthlyCollectionDetails;
        const rsmReportData = this.props.rsmReportData;
        const generalReportData = this.props.generalReportData;
        const employeeData = this.props.employeeData;

        function returnCardNumber(type) {
            var result = employeeData.find(x => x.accountTypeID === type);
            return result === undefined ? [] : result.cardNumber;
        }

        return (
            <div>
                <h3 className="pr-2"><center><u>Employee Crop Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Esate: </b> {searchData.estate}</div>
                    <div className="col"><b>From Date: </b> {searchData.fromDate}</div>
                    <div className="col"><b>To Date: </b> {searchData.toDate}</div>
                    <div className="col"><b>Registration Number: </b> {searchData.regNumber}</div>
                    <div className="col"><b>Employee Type: </b> {searchData.employeeType}</div>
                </div>
                <div className="card" style={{ width: "10rem;" }}>
                    <div className="card-header"><h6>Weigh Details</h6></div>
                    <div className="card-body">
                        {
                            employeeData[0].convertedEmployeeBiometricData !== null ? <img src={employeeData[0].convertedEmployeeBiometricData} width="75" height="75" /> : null
                        }
                        <p className="d-inline pr-3"><b>Bag Count : </b> {detailCard.bagCount}</p>
                        <p className="d-inline pr-3"><b>Net Weight : </b>{detailCard.net} Kg</p>
                        <p className="d-inline pr-3"><b>Extra Kilo : </b>{detailCard.extraKilo} Kg</p>
                    </div>
                </div>
                <div className="col-md-12 pt-2 pb-3">
                    {(monthlyCollectionDetails.employeeType === "1" || monthlyCollectionDetails.employeeType === "2") ?
                        <div>
                            <div><b><u>{monthlyCollectionDetails.employeeType === "2" ? "Rsm Details : " + returnCardNumber(2) : "General Details : " + returnCardNumber(1)}</u></b></div>
                            <div className="table-responsive row-top-gap">
                                <table id="example" className="display dataTable no-footer">
                                    <thead>
                                        <tr>
                                            <th> Date </th>
                                            <th> <center>Bag Count </center> </th>
                                            <th> <center>Net Weight (Kg) </center></th>
                                            <th> <center>Extra Kilo (Kg)</center></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <EmployeeCropTableContent
                                            data={monthlyCollectionDetails.employeeType === "2" ? rsmReportData : generalReportData}
                                            contentRowNames={contentRowNames}
                                            hasEdit={false}
                                        />
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        : null
                    }
                    {monthlyCollectionDetails.employeeType === "0" ?
                        <div>
                            <div className="pt-3 pb-3"><b><u>General Details : {returnCardNumber(1)}</u></b></div>
                            <div className="table-responsive row-top-gap">
                                <table id="general" className="display dataTable no-footer">
                                    <thead>
                                        <tr>
                                            <th> Date </th>
                                            <th> <center>Bag Count </center> </th>
                                            <th> <center>Net Weight (Kg) </center></th>
                                            <th> <center>Extra Kilo (Kg)</center></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <EmployeeCropTableContent
                                            data={generalReportData}
                                            contentRowNames={contentRowNames}
                                            hasEdit={false}
                                        />
                                    </tbody>
                                </table>
                            </div>
                            <div className="pt-3 pb-3"><b><u>Rsm Details : {returnCardNumber(2)}</u></b></div>
                            <div className="table-responsive row-top-gap">
                                <table id="rsm" className="display dataTable no-footer">
                                    <thead>
                                        <tr>
                                            <th> Date </th>
                                            <th> <center>Bag Count </center> </th>
                                            <th> <center>Net Weight (Kg) </center></th>
                                            <th> <center>Extra Kilo (Kg)</center></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <EmployeeCropTableContent
                                            data={rsmReportData}
                                            contentRowNames={contentRowNames}
                                            hasEdit={false}
                                        />
                                    </tbody>
                                </table>
                            </div>
                        </div> : null
                    }
                </div>
            </div>
        );
    }
}